var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 30,
    cy: 30.2012,
    r: 30,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.7773 43.8002H25.8664V26.0675H31.7773V29.023C32.3995 28.2313 33.1893 27.5872 34.0899 27.1368C34.9904 26.6863 35.9796 26.4408 36.9862 26.4177C38.7468 26.4275 40.4316 27.1351 41.6713 28.3852C42.9109 29.6354 43.6042 31.3262 43.5991 33.0867V43.8002H37.6882V33.8256C37.5738 33.027 37.1749 32.2965 36.5648 31.7687C35.9547 31.2409 35.1745 30.9512 34.3677 30.9529C34.0066 30.9643 33.6516 31.0485 33.3239 31.2005C32.9962 31.3526 32.7025 31.5692 32.4606 31.8375C32.2187 32.1058 32.0335 32.4202 31.916 32.7618C31.7986 33.1034 31.7514 33.4653 31.7773 33.8256V43.8002ZM22.9109 43.8002H17V26.0675H22.9109V43.8002ZM19.9555 23.1121C19.1716 23.1121 18.4199 22.8007 17.8656 22.2464C17.3114 21.6922 17 20.9405 17 20.1566C17 19.3728 17.3114 18.6211 17.8656 18.0668C18.4199 17.5125 19.1716 17.2012 19.9555 17.2012C20.7393 17.2012 21.491 17.5125 22.0453 18.0668C22.5995 18.6211 22.9109 19.3728 22.9109 20.1566C22.9109 20.9405 22.5995 21.6922 22.0453 22.2464C21.491 22.8007 20.7393 23.1121 19.9555 23.1121Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4ad471e7fb5aba9c4e2ecbbb6d3f0ca2.svg";
export { ForwardRef as ReactComponent };